(() => {
  const productsFilters = () => {
    const products = document.querySelectorAll('.collection-popular-card');
    const limit = products.length;

    for (const item of document.querySelectorAll('.filters__item')) {      
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const typeTarget = item.dataset.typeTarget;
        for (const element of document.querySelectorAll('.filters__item')) {
          element.classList.remove('filters__item_active');
        }
        item.classList.add('filters__item_active');

        let i = 0;
        for (const element of products) {
          const productType = element.dataset.type;
          if ((productType === typeTarget || typeTarget === "all") && i < limit) {
            element.classList.add('show');
            i++;
          }
          else {
            element.classList.remove('show');
          }
        }
      })
    }
  }

  productsFilters();

  document.addEventListener('shopify:section:load', () => {
    productsFilters();
  });
})();

(() => {
  const initSliders = () =>  {
    const collectionsGridSliders = document.querySelectorAll('.swiper.popular-products__swiper');
    const prevArrowsHorizontal = document.querySelectorAll('.swiper.popular-products__swiper .swiper-btn--prev');
    const nextArrowsHorizontal = document.querySelectorAll('.swiper.popular-products__swiper .swiper-btn--next');
    const paginationHorizontal = document.querySelectorAll('.swiper.popular-products__swiper .swiper-bullets');

    for (const [index, slider] of collectionsGridSliders.entries()) {
      const collectionsGridSlider = new Swiper(slider, {
        slidesPerView: '2',
        spaceBetween: 15,
        watchOverflow: true,
        slidesOffsetAfter: 0,
        slidesOffsetBefore: 1,
        pagination: {
          el: paginationHorizontal[index],
          clickable: true,
          type: 'bullets'
        },
        navigation: {
          nextEl: nextArrowsHorizontal[index],
          prevEl: prevArrowsHorizontal[index],
        },
        breakpoints: {
          989: {
            spaceBetween: 0,
            slidesOffsetAfter: 100,
            slidesPerView: '2',
            slidesPerGroup: 2
          },
          1359: {
            spaceBetween: 10,
            slidesOffsetAfter: 0,
            slidesPerView: '4',
            slidesPerGroup: 4
          }
        }
      });

      collectionsGridSlider.on('slideChange', () => {
        collectionsGridSlider.pagination.render();
        collectionsGridSlider.pagination.update();
      });
    }
  }

  const toggleButton = () => {
    const swiperPagination = document.querySelectorAll('.swiper.popular-products__swiper .swiper-bullets');
    if (swiperPagination) {
      for (const element of swiperPagination) {
        if (element.querySelectorAll('.swiper-pagination-bullet').length <= 1) {
          element.parentElement.parentElement.querySelector('.collections-grid__buttons').classList.add('hide');
        } else {
          element.parentElement.parentElement.querySelector('.collections-grid__buttons').classList.remove('hide');
        }
      }
    }
  }

  const calcHeight = () => {
    const featuredProductsSectionBottom = document.querySelectorAll('.featured-products--bottom');
    for (const section of featuredProductsSectionBottom) {
      const card = section.querySelector('.collections-grid__card');
      const cardWrapper = section.querySelector('.section-collections-grid');
      const featuredProducts = section.querySelector('.collection-product-list');
      if (section && card) {
        const cardHeight = card.getBoundingClientRect().height;
        const cardWrapperHeight = cardWrapper.getBoundingClientRect().height;
        const bullets = section.querySelector('.swiper-pagination--products');

        let bulletsHeight = 0;
        if (bullets) {
          bulletsHeight = bullets.getBoundingClientRect().height + Number.parseFloat(window.getComputedStyle(bullets, null).getPropertyValue("margin-top"));
        }
        
        let featuredProductsHeight = featuredProducts.getBoundingClientRect().height;
        const marginTop = Number.parseFloat(window.getComputedStyle(featuredProducts, null).getPropertyValue("margin-top"));
        featuredProductsHeight = featuredProductsHeight + marginTop;

        section.style.paddingBottom = '0';
        section.style.marginBottom = '0';
        section.style.paddingBottom = `${cardHeight / 2 + featuredProductsHeight - cardHeight - bulletsHeight}px`;
        section.style.marginBottom = `${cardHeight / 2 + cardWrapperHeight - featuredProductsHeight}px`;
      }
    }
  };

  const hoverProductList = () => {
    const productWrappers = document.querySelectorAll('.featured-products__products-wrapper');
    for (const element of productWrappers) {
      const productList = element.querySelector('.collection-product-list');
      productList.addEventListener('mouseenter', (event) => {
        event.target.parentElement.parentElement.querySelector('.collections-grid__buttons').classList.add('active');
      });

      productList.addEventListener('mouseleave', (event) => {
        if (event.relatedTarget !== event.target.parentElement.parentElement.querySelector('.collections-grid__buttons .swiper-btn--next') 
          && event.relatedTarget !== event.target.parentElement.parentElement.querySelector('.collections-grid__buttons .swiper-btn--prev')) {
          event.target.parentElement.parentElement.querySelector('.collections-grid__buttons').classList.remove('active');
        }
      });

      const swiperButtons = element.querySelectorAll('.swiper-btn');
      for (const btn of swiperButtons) {
        btn.addEventListener('mouseleave', (event) => {
          event.target.parentElement.classList.remove('active');
        });
      }
    }
  }

  const positionButtons = () => {
    const featuredProductsSection = document.querySelectorAll('.section-collections-grid');
    for (const section of featuredProductsSection) {
      const cardItemHeight = section.querySelector('.collections-grid__card').getBoundingClientRect().height;
      section.querySelector('.collections-grid__buttons').style.top = `${cardItemHeight / 2}px`;
    }
  }

  const resizeFeaturedProducts = () => {
    const featuredProductsSection = document.querySelectorAll('.section-collections-grid');

    const sectionResizeObserver = new ResizeObserver((entries) => {  
      initSliders();
      toggleButton();
      setTimeout(() => {
        calcHeight();
      }, 500);
      positionButtons();
      // hoverProductList();
    });

    for (const section of featuredProductsSection) {  
      sectionResizeObserver.observe(section);
    }
  }


  document.addEventListener('shopify:section:load', () => {
    resizeFeaturedProducts();
  });

  resizeFeaturedProducts();
})();